import { render, staticRenderFns } from "./Environments.vue?vue&type=template&id=8ba93938&scoped=true"
import script from "./Environments.vue?vue&type=script&lang=js"
export * from "./Environments.vue?vue&type=script&lang=js"
import style0 from "./Environments.vue?vue&type=style&index=0&id=8ba93938&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba93938",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ba93938')) {
      api.createRecord('8ba93938', component.options)
    } else {
      api.reload('8ba93938', component.options)
    }
    module.hot.accept("./Environments.vue?vue&type=template&id=8ba93938&scoped=true", function () {
      api.rerender('8ba93938', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Environments.vue"
export default component.exports